module.exports = __webpack_public_path__ + "media/evolve/assets/icons/fontawesome/solid/level-down-ab0edb5ac4f7479425c73713f56485da.svg";